var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-menu"},[_c('SideMenuBase',{attrs:{"list":_vm.sampleList,"setItemID":_vm.setSideMenu},on:{"clickItem":_vm.clickItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }